import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestListItem', {
    exchangeRateTitle: '{amount} {currency} = {baseAmount} {baseCurrency}',
    draftBadgeText: 'Draft',
});
